export const ONBOARDING_WATERFALL_GENERATION_QUERY_PARAM =
  'onboardingWaterfallGeneration';
export const PENDING_ONBOARDING_WATERFALL_TRACKER_ID = 'pending';
